import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Printd from 'printd'
import utils from "../../../utils/validateScanner"

export default {
  name: 'confirm-line-haul-connection',
  mixins: [utils],
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading
  },
  data: function() {
    return {
      showTable: false,
      isLoadingSearch: false,
      isLoading: false,
      isDisplay: true,
      createdBy: "",
      bagNumber: "", //xb-vadodara8
      bagDetails: {
        bagno: "",
        originhubname: "",
        destinationhubname: "",
        bagtype: "",
        totalshipmentsinbag: "",
        routemode: null
      },
      hubid: ''
    }
  },
  created: function() {},
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.warehouseid = userdetail[0].warehouseid;
    this.createdBy = userdetail[0].email;
    this.hubid = userdetail[0].HubId[0];
    // this.loadBagDetails()
    this.$refs.bagNumber.focus()

  },
  methods: {
    loadBagDetails() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isLoadingSearch = true
          this.input = {}
          axios({
              method: 'GET',
              'url': apiUrl.allocateRuleapi_url + 'getBagDetailsForPrintSticker?BagNo=' + this.bagNumber + '&currentHubId=' + this.hubid,
              'data': this.input,
              headers: {
                'Authorization': 'authkey xB84JJ89Hd25'
              }
            })
            .then(result => {
              var response = result.data
              if (response.ResultCode == 100) {
                if (response.ResultData.length > 0) {
                  this.isLoadingSearch = false;
                  this.showTable = true;
                  this.bagDetails = response.ResultData[0];
                  if(Object.keys(result.data.lossCategorization).length !=0){
							    this.colorCode = result.data.lossCategorization.colorCode;
							    this.colorIcon = result.data.lossCategorization.icon;
						      }
                  this.printerSticker(this.bagDetails);
                  
                }
              } else {
                this.bagDetails = {};
                this.isLoadingSearch = false;
                this.showTable = false;
                this.$alertify.error(result.data.ReturnMessage)
                this.showHideCodeIconInput();
              }
              this.isLoading = false
            }, error => {
              this.isDisplay = false
              this.isLoading = false
              this.showHideCodeIconInput();
              var code = error.response == undefined ? code = 0 : error.response.status;
              if (code == 500) {
                this.$alertify.error(error.response.statusText);
              } else {
                this.$alertify.error(error.response.statusText);
              }
              console.log(error)
            })
        }
      });
    },
    printerSticker(bagDetails) {
      var connectionname1 = bagDetails.connectionname.substring(0, 39);
      var connectionname2 = bagDetails.connectionname.substring(39, 82);
      // var date = moment(bagDetails.bagprintdate).format('DD-MM-YYYY HH:mm:ss')
      var date = bagDetails.bagprintdate;
      let prnData = `^XA
      ^SZ2^JMA
      ^MCY^PMN
      ^PW812
      ~SD12^MD0^MTD
      ~JSN
      ~SD25^MD0
      ^JZY
      ^LH0,0^LRN
      ^XZ
      ^XA
      ^FO150,7
      ^GB0,584,3^FS
      ^FT49,572
      ^CI0
      ^A0B,25,34^FDConnection :^FS
      ^FT95,575
      ^A0B,25,25^FD${connectionname1}^FS
      ^FT136,573
      ^A0B,25,25^FD${connectionname2}^FS
      ^FT180,52
      ^A0N,25,34^FDWWW.XPRESSBEES.COM^FS
      ^FO165,84
      ^BY3^BCN,73,N,N^FD>:${bagDetails.bagno}^FS
      ^FT310,183
      ^A0N,25,34^FD${bagDetails.bagno}^FS
      ^FT180,266
      ^A0N,25,34^FDDestination^FS
      ^FT180,327
      ^A0N,25,34^FDBag Type^FS
      ^FT180,388
      ^A0N,25,34^FDRoute Mode^FS
      ^FT180,449
      ^A0N,25,34^FDNo of Qty^FS
      ^FT180,510
      ^A0N,25,34^FDDate^FS
      ^FT370,268
      ^A0N,25,34^FD: ${bagDetails.destinationhubname}^FS
      ^FT370,329
      ^A0N,25,34^FD: ${bagDetails.bagtype}^FS
      ^FT370,390
      ^A0N,25,34^FD: ${bagDetails.routemode}^FS
      ^FT370,451
      ^A0N,25,34^FD: ${bagDetails.totalshipmentsinbag}^FS
      ^FT370,510
      ^A0N,25,34^FD: ${date}^FS
      ^PQ1,0,1,Y
      ^XZ`;
      console.log(prnData);
      this.input = {
        // connectionname: bagDetails.connectionname,
        // destinationhubname: bagDetails.destinationhubname,
        // bagtype: bagDetails.bagtype,
        // routemode: bagDetails.routemode,
        // totalshipmentsinbag: bagDetails.totalshipmentsinbag,
        // bagno: bagDetails.bagno

        prnData: prnData,
          // 'n\n' +
          // 'M0751\n' +
          // 'KW0400\n' +
          // 'O0220\n' +
          // 'V0\n' +
          // 'f303\n' +
          // 'D\n' +
          // 'L\n' +
          // 'D11\n' +
          // 'A2\n' +
          // '1X1100000010100L001300\n' +
          // '1e6304801990105B' + bagDetails.bagno + '\n' +
          // '1911A1201800165' + bagDetails.bagno + '\n' +
          // '1911A1202670148WWW.XPRESSBEES.COM\n' +
          // '1911A1001450114Destination :\n' +
          // '1911A1001450220' + bagDetails.destinationhubname + '\n' +
          // '1911A1001120114Bag Type :\n' +
          // '1911A1001130220' + bagDetails.bagtype + '\n' +
          // '1911A1000820114Route Mode\n' +
          // '1911A1000820220' + bagDetails.routemode + '\n' +
          // '1911A1000520114No. Of QTY :\n' +
          // '1911A1000520220' + bagDetails.totalshipmentsinbag + '\n' +
          // '4911A1000140039Connection :\n' +
          // '4911A0800140057' + connectionname1 + '\n' +
          // '4911A0800140082' + connectionname2 + '\n' +
          // '1911A1000190114Date :\n' +
          // '1911A1000190220' + date + '\n' +
          // 'Q0001\n' +
          // 'E',
        bagNumber: this.bagNumber
      }

      axios({
          method: "POST",
          url: "http://localhost:4500/printer/printbagsticker",
          data: this.input,
        })
        .then(result => {
          // console.log(result);
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage);
            this.bagNumber = "";
            this.$refs.bagNumber.focus()
            this.$validator.reset();
            this.errors.clear();
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          this.isDisplay = false
          this.isLoading = false
          var code = error.response == undefined ? code = 0 : error.response.status;
          if (code == 500) {
            this.$alertify.error("Printer API error");
            console.log(error.response.statusText);
          } else if (error) {
            this.$alertify.error("Printer not connected")
          }
        })
    },
    resetForm() {
      this.bagNumber = "";
      this.bagDetails = {};
      this.isLoadingSearch = false;
      this.showTable = false;
      this.$validator.reset();
      this.errors.clear();
      this.$refs.bagNumber.focus()
      this.showHideCodeIconInput();
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/BagStickerPrint/BagStickerPrint.js